import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/matches';
import './Matches.css';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import { createLeagues } from '../shared/CreateLeagues';

class Matches extends React.Component {
    async componentDidMount() {
        await this.props.onMatchesLoad(this.props.token);
    }
    componentDidUpdate() {
        this.timer=setTimeout(() => {
            this.props.onMatchesLoad(this.props.token);
        }, 60 * 1000);
    }
    componentWillUnmount(){
        clearTimeout(this.timer);
    }
    createItem = (match) => {
        let homeOddPrice = match.homeUpper ?
            (<span style={{ color: '#00c853' }}>
                ({match.odds}{match.price >= 0 ? `+${match.price}` : match.price})
            </span>) :
            null;
        let awayOddPrice = match.homeUpper ? 
        null : 
        (<span style={{ color: '#00c853' }}>
            ({match.odds}{match.price >= 0 ? `+${match.price}` : match.price})
        </span>);
        return (
            <div key={match.matchId}
                className="column"
                style={(window.innerWidth < 500 ||
                    this.props.lastMatches.matches.length < 14 ||
                    (this.props.selectedLeagues.length > 0 && this.props.selectedLeagues.length < 3)) ?
                    { width: '100%' } : { width: '50%' }}>
                <div className="time">{moment(match.startTime).locale('my').format('LT')}</div>
                <div className="home"><span style={{ color: '#2196f3' }}>
                    {match.homeNo}.</span> {match.home.name}{homeOddPrice}
                </div>
                <div className="score-price" style={{ color: '#ffa726' }}>
                    ({match.goalTotal}{match.goalTotalPrice >= 0 ?
                        `+${match.goalTotalPrice}` : match.goalTotalPrice})
                    </div>
                <div className="away"><span style={{ color: '#2196f3' }}>
                    {match.awayNo}.</span> {match.away.name}{awayOddPrice}
                </div>
            </div>
        );
    }

    render() {
        
        let matchTags = null;
        if (this.props.lastMatches) {
            this.props.lastMatches.matches.sort((a, b) => moment(a.startTime) - moment(b.startTime));
            if (this.props.selectedLeagues.length > 0) {
                matchTags = this.props.lastMatches.matches
                    .filter(match => this.props.selectedLeagues.includes(`${match.league.name}_${match.location.name}`))
                    .map(this.createItem);
            }
            if (this.props.isFirstRender) {
                matchTags = this.props.lastMatches.matches.map(this.createItem);
            }
        }
        return (
            <div className="container">
                <div className="main-layout">
                    <div className="header">
                        <Link to="/leagues">Leagues</Link>
                    </div>
                    <div className="body">
                        {matchTags}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        lastMatches: state.matches.matches,
        selectedLeagues: state.leagues.selectedLeagues,
        isFirstRender: state.leagues.isFirstRender,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onMatchesLoad: (token) => dispatch(actions.matches(token)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Matches));
